
import useSVG from "../../../hooks/useSVG";

function FindYourPath({goToScheduler}) {

    const { UseVirtualPT } = useSVG();

    const description = "Whether you need a little extra guidance or a full treatment plan, our team will get you where you need to go."

    return (
        <div id="v-pt-slider-4" className="v-pt-slides">
            <div id="v-pt-s4-header">
                {UseVirtualPT("path")}
            </div>

            <div id="v-pt-s4-body">
                <h2>Find Your Path!</h2>
                <p>{description}</p>
            </div>
        </div>
    );
}

export default FindYourPath;